import { render, staticRenderFns } from "./DataCardTable.vue?vue&type=template&id=a112688c&scoped=true"
import script from "./DataCardTable.vue?vue&type=script&lang=js"
export * from "./DataCardTable.vue?vue&type=script&lang=js"
import style0 from "./DataCardTable.vue?vue&type=style&index=0&id=a112688c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a112688c",
  null
  
)

export default component.exports